import { render, staticRenderFns } from "./DropdownHead.vue?vue&type=template&id=c34af670&lang=pug&"
import script from "./DropdownHead.vue?vue&type=script&lang=js&"
export * from "./DropdownHead.vue?vue&type=script&lang=js&"
import style0 from "./DropdownHead.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports